<template>
  <router-view v-slot="{ Component }">
    <component v-if="Component" :is="Component"></component>
    <slot v-else />
  </router-view>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CustomRouterView2',
  setup() {},
  components: {},
});
</script>
